module.exports = __webpack_public_path__ + "img/phoenix_kedel_0.6b22dd0b.png";